import type { INotice } from "@airbrake/browser"

const REDACTED = `[Filtered]`
const SECRET_KEY = /^(authorization|jwt|token|access_?token|refresh_?token)$/i
const BEARER_TOKEN = /Bearer\s+[\w.~+/-]+=*/gi

// airbrake-js records console output and request breadcrumbs in
// `context.history`; a logged AxiosError carries its request config, so the
// seller's JWT would otherwise ship to Airbrake with every 401.
const redact = (value: unknown, seen: WeakSet<object>): unknown => {
  if (typeof value === `string`) {
    return value.replace(BEARER_TOKEN, `Bearer ${REDACTED}`)
  }
  if (value === null || typeof value !== `object`) return value
  if (seen.has(value)) return REDACTED
  seen.add(value)
  if (Array.isArray(value)) return value.map((item) => redact(item, seen))

  return Object.fromEntries(
    Object.entries(value).map(([key, entry]) => [
      key,
      SECRET_KEY.test(key) && entry != null ? REDACTED : redact(entry, seen),
    ]),
  )
}

export const redactAirbrakeNotice = (notice: INotice): INotice => ({
  ...notice,
  context: redact(notice.context, new WeakSet()),
  params: redact(notice.params, new WeakSet()),
  session: redact(notice.session, new WeakSet()),
  environment: redact(notice.environment, new WeakSet()),
})
